// extracted by mini-css-extract-plugin
module.exports = {"root":"Sorting_root__juPMO","controls":"Sorting_controls__Ghsau","select":"Sorting_select__7jqKd"};